import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/icons";
import { useStore } from "../../store/store.context";

import "./side-bar.scss";

const SidebarItem = ({ icon, active, onClick }) => {
  return (
    <li>
      <div
        onClick={onClick}
        className={`sidebar-item${active ? " active" : ""}`}
      >
        <McIcon
          color="black"
          icon={icon}
          size="20"
        />
      </div>
    </li>
  );
};

const SideBar = () => {
  const { store, updateStore } = useStore();
  const { showMessagePanel, appLogout } = store;

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    updateStore({ appLogout: true });
  };

  return (
    <div>
      {/* <div className="sidebar-container"> */}
      {/* <nav>
        <SidebarItem
          icon="chatbot"
          active={showMessagePanel}
          onClick={() => updateStore({ showMessagePanel: !showMessagePanel })}
        />
        <SidebarItem
          icon="door-arrow-right"
          active={appLogout}
          onClick={handleLogout}
        />
      </nav> */}
    </div>
  );
};

export default SideBar;
